import { render, staticRenderFns } from "./FileComparison.vue?vue&type=template&id=5922a6c0&"
import script from "./FileComparison.vue?vue&type=script&lang=js&"
export * from "./FileComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports